import { type ReactNode } from 'react';

type Props = { label: string; badge?: boolean };

export function SectionHeader({ label, badge }: Props): ReactNode {
  return (
    <div className="mt-md flex items-center gap-sm sm:mt-lg">
      <span className="text-xs uppercase tracking-wider text-text-tertiary">
        {label}
      </span>
      {badge && (
        <span className="rounded-full bg-white/[0.06] px-sm py-px text-[10px] text-text-tertiary">
          opcional
        </span>
      )}
    </div>
  );
}
